import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewPromoterPageNew from "../../components/User/ViewUserPageNew";



const ViewPromoterPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  id="title" title2="Promoter Management" link2="/promoter" title="View Promoter" />

        {/* AddUserLayer */}
        <ViewPromoterPageNew roles="promoter" />


      </MasterLayout>
    </>
  );
};

export default ViewPromoterPage;
